export const FETCH_STUDENTS = 'FETCH_STUDENTS';
export const STUDENTS_LOADED = 'STUDENTS_LOADED';

export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const USER_LOADED = 'USER_LOADED';

export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS';
export const ACCOUNTS_LOADED = 'ACCOUNTS_LOADED';

export const FETCH_COURSES = 'FETCH_COURSES';
export const COURSES_LOADED = 'COURSES_LOADED';

export const FETCH_ROLES = 'FETCH_ROLES';
export const ROLES_LOADED = 'ROLES_LOADED';

export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS';
export const PERMISSIONS_LOADED = 'PERMISSIONS_LOADED';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js